var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"app"}},[(!_vm.$auth.ready())?_c('div',[_vm._v("\n  \t\t... Loading\n  \t")]):_vm._e(),_vm._v(" "),(_vm.$auth.ready())?_c('div',[_c('vue-full-loading',{attrs:{"event-bus":_vm.loader,"event-show":"startLoadingAnimation","event-hide":"stopLoadingAnimation","label":"Lädt"}}),_vm._v(" "),_c('router-view')],1):_vm._e()])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-6c9ec6a6","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/App.vue
// module id = null
// module chunks = 